// extracted by mini-css-extract-plugin
module.exports = {"root":"IconWarning_root__2HvO-"};